import CashierServiceModel from "../CashierServiceModel";
import UserModel from "./UserModel";
import InvoiceModel from "./InvoiceModel";

export default class InvoiceItemModel extends CashierServiceModel {

  modelName() {
    return 'invoice-items';
  }

  defaults() {
    return {
      id: null,
      user_id: null,
      invoice_id: null,
      currency: null,
      amount: null,
      description: null,
      discountable: null,
      metadata: null,
      quantity: null,
      unit_amount: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      user: null,
      invoice: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      invoice_id: (val) => (this.nullStringMutator(val)),
      currency: (val) => (this.nullStringMutator(val)),
      amount: Number,
      description: (val) => (this.nullStringMutator(val)),
      discountable: Boolean,
      metadata: (val) => (this.nullStringMutator(val)),
      quantity: Number,
      unit_amount: Number,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getUser() {
    return this.getRelatedModel(UserModel, 'user');
  }

  getInvoice() {
    return this.getRelatedModel(InvoiceModel, 'invoice');
  }

}
